function PhotoBanner() {
  return (
    <div className="photoBannerBox">
      <div className="photoTextBox">
        <div className="bannerText">
          <h1>Love Your Skyn</h1>
          <h3>Hours of Operation</h3>
          <h3>Monday Through Friday 9-5</h3>
        </div>
      </div>
      <div className="photoBannerCard">
        <div className="photo1"></div>
      </div>
    </div>
  );
}

export default PhotoBanner;
